import { ListProvider } from 'contexts/ListContext';
import ListLayout from 'layouts/ListLayout';

interface ListRouteProps {
  Component: React.ComponentType;
}

const ListRoute: React.FC<ListRouteProps> = ({ Component }) => {
  return (
    <ListProvider>
      <ListLayout>
        <Component />
      </ListLayout>
    </ListProvider>
  );
};

export default ListRoute;